/**
 * Created by cahyo wibowo on 12/21/18
 */

import {Component, Prop, Vue} from "annotation";

@Component
export default class PropsMixin extends Vue {
	
	@Prop({default: false, type: Boolean})
	public bordered: boolean;
	
	@Prop({default: false, type: Boolean})
	public striped: boolean;
	
	@Prop({default: false, type: Boolean})
	public narrow: boolean;
	
	@Prop({default: false, type: Boolean})
	public isFullwidth: boolean;
	
	@Prop({default: false, type: Boolean})
	public hoverable: boolean;
	
	@Prop({default: false, type: Boolean})
	public isLoading: boolean;
	
	@Prop({default: '', type: String})
	public type: string;
	
	public get headerClassName() {
		return this.type ? ('is-' + this.type) : '';
	}
}
